<div class="container">
  <div class="icon-container">
    <div class="sms-icon"></div>
  </div>
  <div class="content-container">
    <div class="title">SMS MESSAGE</div>
    <div class="message-text">{{ message }}</div>
  </div>
</div>
